import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { supabase } from 'lib/supabase';

// Opens a file from the private "documents" bucket. Stored URLs are signed
// links that expire, so a fresh one-hour link is made on each click; any
// other URL is opened as it is.
const ViewFileButton = ({ url, children = 'View', ...rest }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    if (!url) return;
    setLoading(true);
    try {
      let filePath = '';
      if (url.includes('/storage/v1/object/public/documents/')) {
        filePath = url.split('/storage/v1/object/public/documents/')[1];
      } else if (url.includes('/storage/v1/object/sign/documents/')) {
        filePath = url
          .split('/storage/v1/object/sign/documents/')[1]
          .split('?')[0];
      } else {
        window.open(url, '_blank');
        setLoading(false);
        return;
      }
      const { data, error } = await supabase.storage
        .from('documents')
        .createSignedUrl(filePath, 3600);
      if (error) {
        toast.error('Failed to open document');
        setLoading(false);
        return;
      }
      window.open(data.signedUrl, '_blank');
    } catch (err) {
      toast.error('Failed to open document');
    }
    setLoading(false);
  };

  return (
    <Button
      size="sm"
      variant="outline-secondary"
      onClick={handleClick}
      disabled={loading}
      {...rest}
    >
      {loading ? <Spinner size="sm" animation="border" /> : children}
    </Button>
  );
};

ViewFileButton.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node
};

export default ViewFileButton;
